import React, { Component } from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types' //eslint-disable-line
import { clone } from 'ramda'
import { Button } from 'advenio-components'
import RegisterActivity from './RegisterActivity'
import Meal from './Meal'
import Report from './Report'
import AddPhoto from './AddPhoto'
import Nap from './Nap'
import Drink from './Drink'
import Eat from './Eat'
import SelectKids from './SelectKids'
import KidsToSleep from './KidsToSleep'

const Views = {
  home: { title: 'Registrar Actividad grupal', component: RegisterActivity },
  Food: { title: 'Tipo de Alimentación', component: Meal },
  drink: { title: '¿Cuanto Tomaron?', component: Drink },
  selectKids: { title: '¿Que niños comieron?', component: SelectKids },
  eat: { title: '¿Cuanto Comieron?', component: Eat },
  Report: { title: 'Reporte Especial', component: Report },
  Photo: { title: 'Agregar Foto', component: AddPhoto },
  Nap: { title: 'Siesta', component: Nap },
  kidsToSleep: { title: 'Seleccionar Niños', component: KidsToSleep },
}

const MealAmount = {
  1: {
    id: 1,
    label: 'Nada',
  },
  2: {
    id: 2,
    label: 'Casi Nada',
  },
  3: {
    id: 3,
    label: 'La mitad',
  },
  4: {
    id: 4,
    label: 'Casi Todo',
  },
  5: {
    id: 5,
    label: 'Todo',
  },
}
const Container = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
`

const EmptyClassroomsLabel = styled.div`
  margin: 16px;
  font-size: 24px;
  text-align: center;
`

const HeaderTitle = styled.div`
  height: 70px;
  background-color: #4A90E2;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  position: relative;
`
const ActivityBar = styled.div`
  height: 60px;
  background-color: #4A90E2;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: row;
  position: relative;
`
const TabActivity = styled.div`
  flex: 1;
  height: 60px;
  background-color: #4A90E2;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  position: relative;
  box-shadow: ${props => props.active ? 'inset 0 -3px 0 white' : ''};
`

const NameHeader = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: row;
  padding-top: 8px;
`
const Close = styled.div`
  width: 50px;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  left: 0;
`

const Content = styled.div`
  flex: 1;
  height: auto;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  height: 100%;
`

const NameSpan = styled.span`
  color: #979797;
`
const Img = styled.img`
  padding: 16px;
  cursor: pointer;
`
const ActivitySpan = styled.span`
  color: #F8F8F8;
  opacity: .3;
  font-size: 10PX;
  margin-bottom: 1px;
`
const ActivityValue = styled.span`
  color: #FFF;
`

class GroupActivity extends Component {
  constructor(props) {
    super(props)

    this.state = {
      currentView: 'home',
      oldView: '',
      info: [],
      width: 0,
      meal: true,
      drink: false,
      eat: false,
      isClassroomEmpty: false,
    }
  }

  componentDidMount = () => {
    const { children, user } = this.props
    let initialChilds = []
    if (user.role === 'Nurse') {
      initialChilds = clone(children
        .filter(student => student.checkin.status === "Nurse's Room" && student.checkin.is_virtual_center !== true))
    } else {
      initialChilds = clone(children
        .filter(student => student.checkin.status === 'Advenio' && student.checkin.is_virtual_center !== true))
    }
    if (initialChilds.length === 0) {
      this.setState({ isClassroomEmpty: true })
    }
  }

  setExtraData = info => this.setState({ info })

  getMealName = (info) => {
    if (info.type_id) {
      const foodCategoryTypes = this.props.categories[1].types
      const [foodType] = foodCategoryTypes.filter(type => type.id === Number(info.type_id))
      return foodType.translations.es
    }
    return '-'
  }

  getMealAmount = (info) => {
    if (info.eat) {
      return MealAmount[info.eat].label
    }
    return '-'
  }

  setMealAsDefault = () => {
    this.setState({
      meal: true,
      drink: false,
      eat: false,
    })
  }

  goToView = (view, oldView, category) => {
    if (view === 'drink') {
      this.setState({
        currentView: view,
        oldView,
        category,
        meal: false,
        drink: true,
        eat: false,
      })
    } else if (view === 'eat') {
      this.setState({
        currentView: view,
        oldView,
        category,
        meal: false,
        drink: false,
        eat: true,
      })
    } else {
      this.setState({
        currentView: view,
        oldView,
        category,
      })
    }
  }

  eat = () => {
    this.setState({ meal: false, drink: false, eat: true })
    this.goToView('eat', '','')
  }

  drink = () => {
    this.setState({ meal: false, drink: true, eat: false })
    this.goToView('drink', '','')
  }

  meal = () => {
    this.setState({ meal: true, drink: false, eat: false })
    this.goToView('Food', '',2)
  }


  closeModal = () => {
    this.props.closeModal()
  }

  renderEmptyClassroom = () => (
    <Content>
      <EmptyClassroomsLabel>
        No se puede registrar una actividad grupal porque no hay alumnos presentes
      </EmptyClassroomsLabel>
      <Button
        primary
        onClick={this.closeModal}
      >
        Aceptar
      </Button>
    </Content>
  )

  render() {
    const CurrentView = Views[this.state.currentView]
    return (
      <Container>
        <HeaderTitle>
          <Close>
            {this.state.currentView !== 'home' ?
              <Img src="/assets/whiteBack.svg" onClick={() => this.goToView('home', '', '')} /> :
              <Img src="/assets/whiteClose.svg" onClick={this.closeModal} />
            }
          </Close>
          <span style={{ color: '#FFF' }} >{ CurrentView.title }</span>
          <NameHeader>
            <NameSpan><img src="/assets/group.svg" alt="group" /></NameSpan>
          </NameHeader>
        </HeaderTitle>
        { this.state.currentView === 'Food'
        || this.state.currentView === 'drink'
        || this.state.currentView === 'eat'
        || this.state.currentView === 'selectKids' ?
          <ActivityBar>
            <TabActivity active={this.state.meal} onClick={this.meal}>
              <ActivitySpan>ALIMENTACION</ActivitySpan>
              <ActivityValue>{this.getMealName(this.state.info)}</ActivityValue>
            </TabActivity>
            <TabActivity active={this.state.drink} onClick={this.drink}>
              <ActivitySpan>TOMARON</ActivitySpan>
              <ActivityValue>{this.state.info.drink ? `${this.state.info.drink} oz` : '-' }</ActivityValue>
            </TabActivity>
            <TabActivity active={this.state.eat} onClick={this.eat}>
              <ActivitySpan>COMIERON</ActivitySpan>
              <ActivityValue>{this.getMealAmount(this.state.info)}</ActivityValue>
            </TabActivity>
          </ActivityBar>
          :
          ''
        }
        {
          this.state.isClassroomEmpty ? this.renderEmptyClassroom() : (
            <Content>
              <CurrentView.component
                isGroupActivity
                goToView={this.goToView}
                children={this.props.children}
                setExtraData={this.setExtraData}
                info={this.state.info}
                closeModal={this.closeModal}
                view={this.state.currentView}
                oldView={this.state.oldView}
                categories={this.props.categories}
                category={this.state.category}
                setMealAsDefault={this.setMealAsDefault}
                classrooms={this.props.classrooms}
                postGroupActivity={this.props.postGroupActivity}
                user={this.props.user}
                loading={this.props.loading}
              />
            </Content>
          )
        }
      </Container>
    )
  }
}

GroupActivity.propTypes = {
  closeModal: PropTypes.func.isRequired,
}


export default GroupActivity



// WEBPACK FOOTER //
// ./src/Components/Activity/GroupActivity.jsx